import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Feature, InitialValuesSource } from '../feature'

export const WRITE_INITIAL_VALUES_TO_STATE_ORIGIN =
  'writeInitialValuesToState (effect)'

/**
 * Writes the initial values of the storage into the state of the
 * {@link Feature}
 */
export const writeInitialValuesToState = store.effects.create(
  (
    feature: Feature<any>,
    initialValues: InitialValuesSource<any> | undefined,
  ) =>
    !initialValues
      ? undefined
      : rxjs.of(undefined).pipe(
          // Delays the time before the initial values are retrieved. This is
          // mostly used to wait until the class is instantiated so we can use
          // instance methods
          rxjs.delay(1),
          // Retrieves the initial values
          rxjs.switchMap(() => initialValues),
          // Skip any undefined initial values
          rxjs.filter(TypeChecker.isNotNullish.raw),
          // Only take the first set of values
          rxjs.take(1),
          // Write them to the state
          rxjs.map(values =>
            feature.actions.writeAllProperties
              .from(WRITE_INITIAL_VALUES_TO_STATE_ORIGIN)
              .create({ onlyUpdateState: true, values }),
          ),
        ),
)
